import { Component, OnInit, Input,EventEmitter, Output } from '@angular/core';
import { ShortCodesService } from 'src/app/services/shortcodes.service';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { IScrBaseResponse } from 'src/app/services';

@Component({
  selector: 'app-cancel-shortcode-lease-confirmation-dialog',
  templateUrl: './cancel-shortcodelease-confirmation-dialog.component.html',
  styleUrls: ['./cancel-shortcodelease-confirmation-dialog.component.scss']
})
export class CancelShortCodeLeaseConfirmationDialogComponent
  extends ScrBaseComponent
  implements OnInit
{
  @Input() confirmationMessage?: string;
  @Input() informationMessage?: string;
  @Input() cancelScid?: number;
  @Input() cancelScOrderId?: number;
  @Input() leaseStatus?: string;
  @Input() statusReason?: string;
  @Output() reLoadList= new EventEmitter();
  public isSuccess?: boolean=false;
  public display = false;
  public successMessage!: string;
  

  constructor(
    private shortCodesService: ShortCodesService
  ) {
    super();
  }

  ngOnInit(): void {
    this.clearErrors();
    this.isSuccess = false;
  }

  resetForm() {
   
    this.clearMessages();
  }
  showDialog() {
    this.display = true;
  }
  cancel()
  {
    this.closeDialog();
  }
  cancelLeaseShortCode() {
    let shortCodeStatus;
    if (this.isSuccess) {
     this.reLoadList.emit();
     this.resetForm();
      this.closeDialog();

    } else if (this.cancelScid && this.leaseStatus && this.cancelScOrderId) {
      shortCodeStatus = this.leaseStatus; 
      if ( this.leaseStatus === "Cancelled" && this.statusReason === "NoPay")
       shortCodeStatus = "PendingRenew";
      else if (this.leaseStatus === "Cancelled" && this.statusReason === "NoRenew") 
       shortCodeStatus = "Approved";
      else
      shortCodeStatus = this.leaseStatus;
      this.shortCodesService
        .cancelLeastShortCode(
          'Cancel' + shortCodeStatus,
          this.cancelScid,
          this.cancelScOrderId,
          this.leaseStatus,
          'CancelRequested'
        )
        .subscribe((data: IScrBaseResponse) => {
          if (data.status === 'fail') {
            this.clearMessages();
            this.displayLocalizedError(
              data.messages ? data.messages[0].message : ''
            );
          } else {
            this.isSuccess = true;
            this.successMessage = data.messages ? data.messages[0].message : '';
          }
        });
    }
  }

  closeDialog() {
    this.display = false;
    this.isSuccess=false;
  }
}



